import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup, BtnToolbar } from '@dec/shared';
import { ConfirmDialog } from 'app/core/dialog';
import { useAuthUserContext } from 'app/core/security/authSession';
import { useSpinnerActions } from 'app/layouts/store';
import TaxReturnForm from 'app/modules/FormDefinition/components/Form';
import { type Period, type TaxReturnRequest } from 'app/modules/FormDefinition/models/types';
import { label as labelCommon } from 'app/modules/translation';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { createTaxReturn } from '../../Statements/TaxReturn/services/taxReturn.service';
import { messages, title } from '../../Statements/TaxReturn/translation';

export const TaxReturnCreatePage = () => {
  const { version } = useParams();

  const auth = useAuthUserContext();
  const query = new URLSearchParams(useLocation().search);

  const period = {
    year: Number(query.get('year')),
    taxPeriodicity: query.get('periodicity'),
    taxPeriodicityTypeId: query.get('periodicityTypeId'),
    taxPeriodicityItemId: query.get('periodicityTypeItemId')
  } as Period;

  const { showSpinner, hideSpinner } = useSpinnerActions();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const submit = async (data: TaxReturnRequest) => {
    const ok = await ConfirmDialog({
      titleModal: title(t, 'dialog-confirm'),
      message: messages(t, 'confirm'),
      okButton: t('common.button.submitTaxReturn'),
      cancelButton: labelCommon('cancel')
    });

    if (!ok) {
      return;
    }

    showSpinner();
    try {
      const result = await createTaxReturn(data);
      navigate(`/tax-returns/record/success/${result.taxReturnId}`);
    } finally {
      hideSpinner();
    }
  };

  return (
    <>
      <TaxReturnForm
        submit={submit}
        taxpayerId={auth?.userProfile?.taxpayerId}
        version={version || ''}
        period={period}
      />
      <div>
        <BtnToolbar>
          <BtnGroup>
            <Button
              action={ButtonAction.cancel}
              onClick={() => {
                navigate(-1);
              }}
            />
          </BtnGroup>
          <BtnGroup>
            <Button
              variant="primary"
              type="submit"
              action={ButtonAction.save}
              text={t('common.button.submitTaxReturn')}
              form="TaxReturnForm"
            />
          </BtnGroup>
        </BtnToolbar>
      </div>
    </>
  );
};
